import { API_URL } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { CreateOptionGroupRequest, CreateOptionGroupResponse } from './types';

const GENERIC_ERROR_MESSAGE = 'Something went wrong whilst creating the option group';

export const createOptionGroup = async (requestBody: CreateOptionGroupRequest): Promise<CreateOptionGroupResponse> => {
  const url = `${API_URL}/option-groups`;

  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!res.ok) {
    let errorBody: { message?: string } | null;
    try {
      errorBody = await res.json();
    } catch {
      errorBody = null;
    }
    throw new Error(errorBody?.message || GENERIC_ERROR_MESSAGE);
  }

  return (await res.json()).data[0];
};
